export enum SystemRoles {
  SalesRepresentative = 'sales_representative',
  Procurement = 'procurement',
  Dispatcher = 'dispatcher',
}
